export const DETAIL_DATE_PARAM_FORMAT = 'yyyy-MM-dd';
export const PRIVACY_POLICY_AND_RESEARCH_CONSENT_FORM_NOTION_URL_EN =
  'https://www.notion.so/jinsungoo/Privacy-Policy-Consent-Form-413087ddc0674afe9fc951e703236489';

export const PRIVACY_POLICY_AND_RESEARCH_CONSENT_FORM_NOTION_URL_KO =
  'https://jinsungoo.notion.site/fbbbfa2ea098431b86dbe75b320ea1c4';

export const LEARN_MORE_ABOUT_WHOAMI_TODAY_NOTION_URL =
  'https://www.notion.so/jinsungoo/What-is-WhoAmI-Today-TBU-7466713e676a42eca7d7d99c3ac341e9';

// Ver.W redirection path
export const FRIEND_DEFAULT_REDIRECTION_PATH = '/friends';

// Ver.Q redirection path
export const FRIENDS_Q_DEFAULT_REDIRECTION_PATH = '/feed';

export const FEED_DEFAULT_REDIRECTION_PATH = '/feed';

export const INVITATION_LINK = 'https://whoamitoday.page.link/invite-friend';

export const RESEARCH_SIGNUP_FORM_URL_EN =
  'https://uwashington.qualtrics.com/jfe/form/SV_efBjsvQ1uNNaISi';
export const RESEARCH_SIGNUP_FORM_URL_KO =
  'https://uwashington.qualtrics.com/jfe/form/SV_ebKQeBfG6igRcMe';

export const RESEARCH_INQUIRY_KAKAOTALK_LINK = 'https://open.kakao.com/o/svf9rklh';

export const RESEARCH_INQUIRY_INSTAGRAM_LINK = 'https://www.instagram.com/whoami.today.official/';

export const RESEARCH_INQUIRY_DISCORD_LINK = 'https://discordapp.com/users/1221863102769922160';

export const USER_MANUAL_URL =
  'https://drive.google.com/drive/folders/131GPATMKThegtTlw86OtBYOgfx1uu6S4?usp=sharing';

export const ONBOARDING_VIDEO_URL = 'https://tinyurl.com/wit-videos';

export const DAILY_SURVEY_URL_EN = 'https://uwashington.qualtrics.com/jfe/form/SV_b4017RNxNe5wvMq';
export const DAILY_SURVEY_URL_KO = 'https://uwashington.qualtrics.com/jfe/form/SV_cCnY8BhEGcTrdrM';

export const QUESTION_SUGGEST_URL_EN =
  'https://uwashington.qualtrics.com/jfe/form/SV_2adjX3VMIwBGt4q';
export const QUESTION_SUGGEST_URL_KO =
  'https://uwashington.qualtrics.com/jfe/form/SV_8Idyexv0QaBrRae';
